import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { VfModalShellComponent } from '@app/shared/common/components/modal-shell/vf-modal-shell.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from '../../auth/data.service';
import { CopyMoveMsFileInputDto, CreateFileInputDto, CreateFolderDto, FileParameter, LinkServiceProxy, OneDriveServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Subject, Subscription } from 'rxjs';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { cloneDeep } from 'lodash';
import { debounceTime, take } from '@node_modules/rxjs/operators';

@Component({
  selector: 'vf-copy-or-move-to-popup',
  templateUrl: './copy-or-move-to-popup.component.html'
})
export class CopyOrMoveToPopupComponent extends AppComponentBase implements OnInit, OnChanges {

  @ViewChild('copyOrMoveToPopup') modal: ModalDirective;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() entityObj: any;
  @Input() isCopy: boolean;
  @Input() showPopup: boolean;
  @ViewChild('copyOrMoveProgressModal') copyOrMoveProgressModal: ModalDirective;
  @ViewChild('operationErrorShell') operationErrorShell: VfModalShellComponent;
  sharePointSitesData: Array<any> = new Array<any>();
  isSaving = false;
  isUploadFiles = false;
  isShowAddItem = false;
  noResultFound = false;
  isFolderEmpty = false;
  fileUploadError = false;
  isShowAddLibrary = false;
  isAllItemsSelected = false;
  isAllDrivesSelected = false;
  isAllLibrarySelected = false;
  isSharePointSitesLoading = false;
  level = 1;
  fileCtrl: any;
  selectedSiteData: any;
  selectedDriveData: any;
  selectedItem: Array<any> = new Array<any>();;
  driveCategoryId: number;
  driveItems: Array<any> = new Array<any>();
  fileRawData: Array<any> = new Array<any>();
  currentItemIndex: number = -1;
  itemsHistory: any[][] = [];
  uploadingItems: any[] = [];
  fileErrorMsg = '';
  searchTextOnL1 = '';
  searchTextOnL2 = '';
  searchTextOnL3 = '';
  searchTextOnL4 = '';
  searchTextOnL5 = '';
  searchTextOnL0 = '';
  selectedDocType = 1;
  delFileItem: any;
  searchText = '';
  subs = new Subscription();
  moveOrCopyItems: Array<any> = new Array<any>();
  copyOrMoveIndex = 0;
  moveOrCopyToLocationName = '';
  copyMoveMsFileInputs: Array<any> = new Array<any>();
  originalData: any;
  moveOnOperation = '';
  operationError: { title?: string; message: string; cancelLabel?: string; saveLabel?: string } | undefined;
  isOperationErrorShown = false;
  private _lastErrorCode = '';
  private _pendingRenameItems: any[] = [];
  nextBatchLink = '';
  selectedDriveId = '';
  isMoreDataLoading = false;
  noSharePointSiteResultFound = false;
  activeTab: 'sharepoint' | 'onedrive' = 'sharepoint';
  newFolderName = '';
  isShowNewFolderInput = false;
  spBreadcrumb: any[] = [];
  private onSearching: Subject<any> = new Subject();
  constructor(injector: Injector,
    private dataService: DataService,
    private _linkService: LinkServiceProxy,
    private _oneDriveService: OneDriveServiceProxy) {
    super(injector);
    this.onSearching
          .pipe(debounceTime(1000))
          .subscribe((result) => {
            this.getSharepointSites();
          });
  }

  ngOnInit() {
    if (this.dataService.closeFileExpolorerModal.observers.length === 0) {
      this.subs.add(this.dataService.closeFileExpolorerModal.subscribe(() => {
        this.close();
      }));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.entityObj && changes.entityObj.currentValue !== undefined) {
      this.entityObj = changes.entityObj.currentValue;
      this.show(this.entityObj);
    }
    if (changes.isCopy && changes.isCopy.currentValue !== undefined) {
      this.isCopy = changes.isCopy.currentValue;
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.dataService.closeFileExpolorerModal.observers = [];
  }

  private getSharepointSites() {
    if (!this.isSharePointSitesLoading) {
      this.isSharePointSitesLoading = true;
      this._oneDriveService.getSharePointSites(this.searchTextOnL1).subscribe(result => {
        this.isSharePointSitesLoading = false;
        if (!result.isError) {
          if (result.responseData.length > 0) {
            this.sharePointSitesData = result.responseData;
            this.sharePointSitesData.forEach(element => {
              element.isSelected = false;
            });
            this.noSharePointSiteResultFound = false;
          } else {
            this.sharePointSitesData = [];
            this.noSharePointSiteResultFound = true;
          }
        }
      });
    }
  }

  private initializeSearch() {
    this.noResultFound = false;
    this.searchText = '';
    $('.file-explorer-modal-search .input-group-append').hide();
    $('.file-explorer-modal-search .form-control').on('keyup blur', function () {
      let div = $('.file-explorer-modal-search .input-group-append');
      if ($('.file-explorer-modal-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.file-explorer-modal-search .input-group-append').on('click', function () {
      $('.file-explorer-modal-search .form-control').trigger('focus');
    });
  }

  private initializeSearchOnLevel2() {
    this.noResultFound = false;
    this.searchTextOnL2 = '';
    // $('.level-2-search .input-group-append').hide();
    // $('.level-2-search .form-control').on('keyup blur', function () {
    //   let div = $('.level-2-search .input-group-append');
    //   if ($('.level-2-search .form-control').val() !== '') {
    //     $(this).addClass('focus');
    //     div.show();
    //   } else {
    //     div.hide();
    //     $(this).removeClass('focus');
    //   }
    // });
    // $('.level-2-search .input-group-append').on('click', function () {
    //   $('.level-2-search .form-control').trigger('focus');
    // });

    $('.level-2-search .input-group-append').hide();
    $('.level-2-search .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.level-2-search .input-group-append');
        if ($('.level-2-search .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }  
      }, 50);
    });
    $('.level-2-search .input-group-append').on('click', function () {
      $('.level-2-search .form-control').trigger('focus');
      $(this).hide();
    });
  }

  private initializeSearchOnLevel3() {
    this.noResultFound = false;
    this.searchTextOnL3 = '';
    // $('.level-3-search .input-group-append').hide();
    // $('.level-3-search .form-control').on('keyup blur', function () {
    //   let div = $('.level-3-search .input-group-append');
    //   if ($('.level-3-search .form-control').val() !== '') {
    //     $(this).addClass('focus');
    //     div.show();
    //   } else {
    //     div.hide();
    //     $(this).removeClass('focus');
    //   }
    // });
    // $('.level-3-search .input-group-append').on('click', function () {
    //   $('.level-3-search .form-control').trigger('focus');
    // });

    $('.level-3-search .input-group-append').hide();
    $('.level-3-search .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.level-3-search .input-group-append');
        if ($('.level-3-search .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }  
      }, 50);
    });
    $('.level-3-search .input-group-append').on('click', function () {
      $('.level-3-search .form-control').trigger('focus');
      $(this).hide();
    });
  }

  private initializeSearchOnLevel4() {
    this.noResultFound = false;
    this.searchTextOnL4 = '';
    // $('.level-4-search .input-group-append').hide();
    // $('.level-4-search .form-control').on('keyup blur', function () {
    //   let div = $('.level-4-search .input-group-append');
    //   if ($('.level-4-search .form-control').val() !== '') {
    //     $(this).addClass('focus');
    //     div.show();
    //   } else {
    //     div.hide();
    //     $(this).removeClass('focus');
    //   }
    // });
    // $('.level-4-search .input-group-append').on('click', function () {
    //   $('.level-4-search .form-control').trigger('focus');
    // });

    $('.level-4-search .input-group-append').hide();
    $('.level-4-search .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.level-4-search .input-group-append');
        if ($('.level-4-search .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }  
      }, 50);
    });
    $('.level-4-search .input-group-append').on('click', function () {
      $('.level-4-search .form-control').trigger('focus');
      $(this).hide();
    });
  }

  private initializeSearchOnLevel5() {
    this.noResultFound = false;
    this.searchTextOnL5 = '';
    // $('.level-5-search .input-group-append').hide();
    // $('.level-5-search .form-control').on('keyup blur', function () {
    //   let div = $('.level-5-search .input-group-append');
    //   if ($('.level-5-search .form-control').val() !== '') {
    //     $(this).addClass('focus');
    //     div.show();
    //   } else {
    //     div.hide();
    //     $(this).removeClass('focus');
    //   }
    // });
    // $('.level-5-search .input-group-append').on('click', function () {
    //   $('.level-5-search .form-control').trigger('focus');
    // });

    $('.level-5-search .input-group-append').hide();
    $('.level-5-search .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.level-5-search .input-group-append');
        if ($('.level-5-search .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }  
      }, 50);
    });
    $('.level-5-search .input-group-append').on('click', function () {
      $('.level-5-search .form-control').trigger('focus');
      $(this).hide();
    });
  }

  private initializeSearchOnLevel0() {
    this.noResultFound = false;
    this.searchTextOnL0 = '';
    // $('.level-0-search .input-group-append').hide();
    // $('.level-0-search .form-control').on('keyup blur', function () {
    //   let div = $('.level-0-search .input-group-append');
    //   if ($('.level-0-search .form-control').val() !== '') {
    //     $(this).addClass('focus');
    //     div.show();
    //   } else {
    //     div.hide();
    //     $(this).removeClass('focus');
    //   }
    // });
    // $('.level-0-search .input-group-append').on('click', function () {
    //   $('.level-0-search .form-control').trigger('focus');
    // });

    $('.level-0-search .input-group-append').hide();
    $('.level-0-search .form-control').on('keyup blur', function (event) {
      setTimeout(() => {
        let divapp = $('.level-0-search .input-group-append');
        if ($('.level-0-search .form-control').val() !== '') {
          $(this).addClass('focus');
          divapp.show();
        } else {
          divapp.hide();
          $(this).removeClass('focus');
        }  
      }, 50);
    });
    $('.level-0-search .input-group-append').on('click', function () {
      $('.level-0-search .form-control').trigger('focus');
      $(this).hide();
    });
  }

  private copyMsFileFolder(input: CopyMoveMsFileInputDto, item) {
    this._oneDriveService.copyMsFile(input).subscribe(result => {
      this.processMsFiles(result, input, item);
    });
  }

  private moveMsFileFolder(input: CopyMoveMsFileInputDto, item, moveOn: string) {
    this._oneDriveService.moveMsFile(input).subscribe(result => {
      this.processMsFiles(result, input, item, moveOn);
    });
  }

  private processMsFiles(result: any, input: CopyMoveMsFileInputDto, item: any, moveOn?: string): void {
    if (!result.isError) {
      let idxItem = this.moveOrCopyItems.findIndex(x => x.fileId === input.fileId);
      if (idxItem > -1) {
        this.moveOrCopyItems.splice(idxItem, 1);
      }
      if (this.moveOrCopyItems.length === 0) {
        const msg = this.isCopy ? 'Your items were <b>copied successfully!</b>' : 'Your items were <b>moved successfully!</b>';
        this.toastr.success(msg, null, this.toastrOptions);
      } 
        this.dataService.refreshListAfterCopyOrMove.next();
        this.dataService.refreshFilesSlider.next();
    } else if (result.errorMessage) {
      this.operationError = AppConsts.oneDriveErrors[result.errorMessage] ?? {message: result.errorMessage};
      if (result.errorMessage === '106' || result.errorMessage === '107' || result.errorMessage === '111' || result.errorMessage === '114') {
        this.copyMoveMsFileInputs.push(item);
        if (moveOn) { this.moveOnOperation = moveOn; }
      } else if (result.errorMessage === '101') {
        this._pendingRenameItems.push(item);
      }
      // this.dataService.moveCopyBadgeClear.next();
      this._showOperationError();
    }
    this.closeProgressModal();
  }

  private createLibrary(event) {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    this.isSaving = true;
    let input: CreateFolderDto = new CreateFolderDto();
    input.name = value;
    input.siteId = this.selectedSiteData.id;
    this._oneDriveService.createDocumentLibrary(input).subscribe(result => {
      if (!result.isError) {
        this.isSaving = false;
        event.target.innerText = '';
        this.goToDrivesBySiteId(this.selectedSiteData);
        let options = this.toastrOptions;
        this.toastr
          .success('Library created successfully.',
            null, options);
      } else {
        this.isSaving = false;
        let options = this.toastrOptions;
        this.toastr
          .error('Error while creating library.',
            null, options);
      }
    });
  }

  private checkIfItemsToShowOnLevel5() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel4() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel3() {
    let noOfIsShowItems = this.selectedDriveData.children.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel2() {
    let noOfIsShowItems = this.selectedSiteData.drives.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel1() {
    let noOfIsShowItems = this.sharePointSitesData.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private checkIfItemsToShowOnLevel0() {
    let noOfIsShowItems = this.driveItems.filter(x => x.isShow).length;
    if (noOfIsShowItems === 0) {
      this.noResultFound = true;
    } else {
      this.noResultFound = false;
    }
  }

  private clearData() {
    this.originalData = null;
    this.moveOnOperation = '';
    this.spBreadcrumb = [];
  }

  show(data): void {
    this.originalData = data;
    this.activeTab = 'sharepoint';
    this.isShowNewFolderInput = false;
    this.newFolderName = '';
    if (data) {
      if (data.items && data.items.length > 0) {
        this.moveOrCopyItems = data.items;
      }
      if (data.type) {
        if (data.type === 'copy' || data.type === 'copyWithin') {
          this.isCopy = true;
        } else {
          this.isCopy = false;
        }
      }
      if (data.selectedLocation) {
        // go to the selected location
        let selectedLocationObj = cloneDeep(data.selectedLocation);
        const breadcrumbCallback = () => this.fetchBreadcrumb(data.selectedLocation);
        if (selectedLocationObj.extension === 'documentLibrary') {
          let input = selectedLocationObj;
          this.getSelectedLocationItemsOfDrive(input, breadcrumbCallback);
        } else {
          this.getSelectedLocationItems(data.selectedLocation, breadcrumbCallback);
        }
      } else {
        this.spBreadcrumb = [];
        this.level = 1;
        this.getSharepointSites();
        setTimeout(() => {
          this.initializeSearch();
          this.initializeSearchOnLevel1();
        }, 1000);
      }
    }
    $('body').addClass('task-modal-body');
    this.modal.show();
    this.updateBodyForCenterModalShow();
    setTimeout(() => {
        this.initializeSearchOnLevel1();
    }, 1000);
  }

  refreshItemsOnLevel0(item) {
    this.isSharePointSitesLoading = true;
    this.level = 0;
    setTimeout(() => {
      this.initializeSearchOnLevel0();
    }, 100);
    this.isFolderEmpty = false;
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.id ? item.parentReference.driveId : undefined, item.id && item.parentReference?.driveId !== item.id ? item.id : undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
            this.refreshItemsInItemsHistory(this.driveItems);
          } else {
            this.isFolderEmpty = true;
          }
          // this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
    // if (item.id) {
    //   // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         element.isShow = true;
    //   //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //   //         if (selectedItemsIdz > -1) {
    //   //           element.isShow = false;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //   }
    //   // });
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(item.parentReference.driveId, item.id, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             element.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         this.setItems(this.driveItems);
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // } else {
    //   // this._oneDriveService.getMyFilesOnOneDrive().subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         element.isShow = true;
    //   //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //   //         if (selectedItemsIdz > -1) {
    //   //           element.isShow = false;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //   }
    //   // });
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             element.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // }
  }

  getSelectedLocationItemsOfDrive(item, onSuccess?: () => void) {
    this.isSharePointSitesLoading = true;
    this.level = 0;
    setTimeout(() => {
      this.initializeSearchOnLevel0();
    }, 100);
    this.selectedItem.push(item);
    this.isFolderEmpty = false;
    // this._oneDriveService.getSharePointDriveChildrenByDriveId(item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //         if (selectedItemsIdz > -1) {
    //           element.isShow = false;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.id, undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        this.driveItems = [];
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
        onSuccess?.();
      } else {
        // show error
      }
    });
  }

  getSelectedLocationItems(item, onSuccess?: () => void) {
    this.isSharePointSitesLoading = true;
    this.level = 0;
    setTimeout(() => {
      this.initializeSearchOnLevel0();
    }, 100);
    this.isFolderEmpty = false;
    this.selectedItem.push(item);
    // Update spBreadcrumb when navigating into a sub-folder
    if (this.spBreadcrumb.length > 0) {
      const idx = this.spBreadcrumb.findIndex(x => x.id === item.id);
      if (idx > -1) {
        this.spBreadcrumb.splice(idx + 1);
      } else {
        this.spBreadcrumb.push({ id: item.id, name: item.name, extension: 'folder', parentReference: item.parentReference, bcType: 'folder' });
      }
    }
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.id ? item.parentReference.driveId : undefined, item.id && item.parentReference?.driveId !== item.id ? item.id : undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
        onSuccess?.();
      }
    });
    // if (item.id) {
    //   // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         element.isShow = true;
    //   //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //   //         if (selectedItemsIdz > -1) {
    //   //           element.isShow = false;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //     this.setItems(this.driveItems);
    //   //   }
    //   // });
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(item.parentReference.driveId, item.id, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             element.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         this.setItems(this.driveItems);
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // } else {
    //   // this._oneDriveService.getMyFilesOnOneDrive().subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         element.isShow = true;
    //   //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //   //         if (selectedItemsIdz > -1) {
    //   //           element.isShow = false;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //     this.setItems(this.driveItems);
    //   //   }
    //   // });
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             element.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         this.setItems(this.driveItems);
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // }
  }

  goBack0(): void {
    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.driveItems = this.itemsHistory[this.currentItemIndex];
      this.driveItems.forEach(element => {
        element.isSelected = false;
      });
      this.itemsHistory.pop();
    } else {
      this.close();
      // clear the item history
      this.itemsHistory = [];
    }
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    if (this.selectedItem.length > 0) {
      this.selectedItem.pop();
    }
    if (this.spBreadcrumb.length > 0) {
      this.spBreadcrumb.pop();
    }
    this.isAllItemsSelected = false;
  }

  close(): void {
    if (this.modal.isShown) {
      if (!this.copyOrMoveProgressModal.isShown) {
        this.clearData();
        this.onClose.emit();
        this.updateBodyForCenterModalHide();
      }
      this.modal.hide();
    }
  }

  goToDrivesBySiteId(site) {
    this.isSharePointSitesLoading = true;
    this.isFolderEmpty = false;
    this.level = 2;
    setTimeout(() => {
      this.initializeSearchOnLevel2();
    }, 100);
    this.isShowAddLibrary = false;
    this.selectedSiteData = site;
    this.selectedSiteData.drives = [];
    this._oneDriveService.getDrivesBySiteId(site.id).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        this.level = 2;
        if (result.responseData.length > 0) {
          this.sharePointSitesData.forEach(element => {
            if (element.id === site.id) {
              element.isSelected = true;
              element.drives = result.responseData;
              element.drives.forEach(drive => {
                drive.isSelected = false;
                drive.isShow = true;
                let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
                if (selectedItemsIdz > -1) {
                  element.isShow = false;
                }
              });
              this.selectedSiteData = element;
              this.checkIfItemsToShowOnLevel2();
            }
          });
        } else {
          this.isFolderEmpty = true;
        }
      }
    });
  }

  backToSelectLocation() {
    this.level = 1;
    this.isFolderEmpty = false;
    this.isShowAddLibrary = false;
    this.selectedSiteData = null;
  }

  goToChildrenOfDrive(drive) {
    this.isSharePointSitesLoading = true;
    this.level = 3;
    setTimeout(() => {
      this.initializeSearchOnLevel3();
    }, 100);
    this.isFolderEmpty = false;
    this.selectedSiteData.drives.forEach(element => {
      if (element.id === drive.id) {
        this.selectedDriveId = drive.id;
        element.isSelected = true;
        element.children = [];
        this.selectedDriveData = element;
      }
    });
    // this._oneDriveService.getSharePointDriveChildrenByDriveId(drive.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.selectedSiteData.drives.forEach(element => {
    //         if (element.id === drive.id) {
    //           element.isSelected = true;
    //           element.children = result.responseData;
    //           element.children.forEach(child => {
    //             child.isSelected = false;
    //             child.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //           this.selectedDriveData = element;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //   }
    // });

    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(drive.id, undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        this.driveItems = [];
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.selectedSiteData.drives.forEach(element => {
              if (element.id === drive.id) {
                element.isSelected = true;
                element.children = result.responseData['item1'];
                element.children.forEach(child => {
                  child.isSelected = false;
                  child.isShow = true;
                  let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
                  if (selectedItemsIdz > -1) {
                    element.isShow = false;
                  }
                });
                this.selectedDriveData = element;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      } else {
        // show error
      }
    });
  }

  getMoreChildrenOfDrive(event?: any) {
    if (this.nextBatchLink !== '' && !this.isMoreDataLoading) {
      this.isMoreDataLoading = true;
      this._oneDriveService.getMsFiles(this.selectedDriveId, undefined, this.nextBatchLink, undefined).subscribe(result => {
        this.isMoreDataLoading = false;
        if (!result.isError) {
          if (result.responseData) {
            if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
              this.selectedSiteData.drives.forEach(element => {
                if (element.id === this.selectedDriveId) {
                  element.isSelected = true;
                  element.children.push(...result.responseData['item1']);
                  element.children.forEach(child => {
                    child.isSelected = false;
                    child.isShow = true;
                    let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
                    if (selectedItemsIdz > -1) {
                      element.isShow = false;
                    }
                  });
                  this.selectedDriveData = element;
                }
              });
            }
            if (result.responseData['item2']) {
              this.nextBatchLink = result.responseData['item2'];
            } else {
              this.nextBatchLink = '';
            }
          }
        }
      });
    }
  }

  backToSelectedDrive() {
    this.level = 2;
    this.selectedDriveData = null;
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    setTimeout(() => {
      this.initializeSearchOnLevel2();
    }, 100);
    this.selectedSiteData.drives.forEach(element => {
      element.isSelected = false;
    });
  }

  getDriveItems(item) {
    this.isSharePointSitesLoading = true;
    this.level = 5;
    setTimeout(() => {
      this.initializeSearchOnLevel5();
    }, 100);
    this.selectedItem.push(item);
    this.selectedDriveData.children.forEach(element => {
      if (element.id === item.id) {
        element.isSelected = true;
      }
    });
    this.isFolderEmpty = false;
    // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //         if (selectedItemsIdz > -1) {
    //           element.isShow = false;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  backToSelectedDriveItem() {
    this.level = 3;
    this.driveItems = [];
    setTimeout(() => {
      this.initializeSearchOnLevel3();
    }, 100);
    this.selectedDriveData.children.forEach(element => {
      element.isSelected = false;
    });
  }

  goBack(): void {
    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.driveItems = this.itemsHistory[this.currentItemIndex];
      this.driveItems.forEach(element => {
        element.isSelected = false;
      });
      this.itemsHistory.pop();
    } else {
      this.backToSelectLocation();
      // clear the item history
      this.itemsHistory = [];
    }
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    if (this.selectedItem.length > 0) {
      this.selectedItem.pop();
    }
    this.isAllItemsSelected = false;
  }

  goBackSP(): void {
    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.driveItems = this.itemsHistory[this.currentItemIndex];
      this.driveItems.forEach(element => {
        element.isSelected = false;
      });
      this.itemsHistory.pop();
    } else {
      this.backToSelectedDriveItem();
      // clear the item history
      this.itemsHistory = [];
    }
    this.isFolderEmpty = false;
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    if (this.selectedItem.length > 0) {
      this.selectedItem.pop();
    }
    this.isAllItemsSelected = false;
  }

  setItems(items: any[]): void {
    this.itemsHistory.push([...items]);
    this.currentItemIndex = this.itemsHistory.length - 1;
  }

  refreshItemsInItemsHistory(items: any[]): void {
    this.itemsHistory[this.currentItemIndex] = items;
  }

  onItemSelected(item: any): void {
    this.removeSearchOnLevel4();
    this.isFolderEmpty = false;
    this.isSharePointSitesLoading = true;
    this.selectedItem.push(item);
    // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //         if (selectedItemsIdz > -1) {
    //           element.isShow = false;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  getMyFilesOnOneDrive(): void {
    this.isSharePointSitesLoading = true;
    this.level = 4;
    setTimeout(() => {
      this.initializeSearchOnLevel4();
    }, 100);
    this.selectedItem.push({ name: 'My Files' });
    // this._oneDriveService.getMyFilesOnOneDrive().subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //         if (selectedItemsIdz > -1) {
    //           element.isShow = false;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //     this.setItems(this.driveItems);
    //   }
    // });

    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(undefined, undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
          } else {
            this.isFolderEmpty = true;
          }
          this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  getMoreMyFiles(event?: any) {
    if (this.nextBatchLink !== '' && !this.isMoreDataLoading) {
      this.isMoreDataLoading = true;
      this._oneDriveService.getMsFiles(undefined, undefined, this.nextBatchLink, undefined).subscribe(result => {
        this.isMoreDataLoading = false;
        if (!result.isError) {
          if (result.responseData) {
            if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
              this.driveItems.push(...result.responseData['item1']);
              this.driveItems.forEach(element => {
                element.isSelected = false;
                element.isShow = true;
                let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
                if (selectedItemsIdz > -1) {
                  element.isShow = false;
                }
              });
            }
            if (result.responseData['item2']) {
              this.nextBatchLink = result.responseData['item2'];
            } else {
              this.nextBatchLink = '';
            }
          }
        }
      });
    }
  }

  applySearch() {
    this.searchText = this.searchText.trim();
    if (this.level === 0) {
      this.applySearchOnLevel0();
    } else if (this.level === 1) {
      this.applySearchOnLevel1();
    } else if (this.level === 2) {
      this.searchTextOnL2 = this.searchText;
      this.applySearchOnLevel2();
    } else if (this.level === 3) {
      this.searchTextOnL3 = this.searchText;
      this.applySearchOnLevel3();
    } else if (this.level === 4) {
      this.searchTextOnL4 = this.searchText;
      this.applySearchOnLevel4();
    } else if (this.level > 4) {
      this.searchTextOnL5 = this.searchText;
      this.applySearchOnLevel5();
    }
  }

  removeSearch() {
    this.searchText = '';
    if (this.level === 0) {
      this.removeSearchOnLevel0();
    } else if (this.level === 1) {
      this.removeSearchOnLevel1();
    } else if (this.level === 2) {
      this.removeSearchOnLevel2();
    } else if (this.level === 3) {
      this.removeSearchOnLevel3();
    } else if (this.level === 4) {
      this.removeSearchOnLevel4();
    } else if (this.level > 4) {
      this.removeSearchOnLevel5();
    }
  }

  applySearchOnLevel0() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL0.toLowerCase()) > -1) {
          element.isShow = true;
          let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
          if (selectedItemsIdz > -1) {
            element.isShow = false;
          }
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel0();
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel0() {
    this.searchTextOnL0 = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
        let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
        if (selectedItemsIdz > -1) {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel0();
    } else {
      this.noResultFound = false;
    }
  }

  // applySearchOnLevel1() {
  //   if (this.sharePointSitesData.length > 0) {
  //     this.sharePointSitesData.forEach(element => {
  //       if (element.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
  //         element.isShow = true;
  //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
  //         if (selectedItemsIdz > -1) {
  //           element.isShow = false;
  //         }
  //       } else {
  //         element.isShow = false;
  //       }
  //     });
  //     this.checkIfItemsToShowOnLevel1();
  //   } else {
  //     this.noResultFound = false;
  //   }
  // }

  // removeSearchOnLevel1() {
  //   this.searchText = '';
  //   if (this.sharePointSitesData.length > 0) {
  //     this.sharePointSitesData.forEach(element => {
  //       element.isShow = true;
  //       let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
  //       if (selectedItemsIdz > -1) {
  //         element.isShow = false;
  //       }
  //     });
  //     this.checkIfItemsToShowOnLevel1();
  //   } else {
  //     this.noResultFound = false;
  //   }
  // }

  applySearchOnLevel2() {
    if (this.selectedSiteData.drives.length > 0) {
      this.selectedSiteData.drives.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL2.toLowerCase()) > -1) {
          element.isShow = true;
          let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
          if (selectedItemsIdz > -1) {
            element.isShow = false;
          }
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel2();
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel2() {
    this.searchTextOnL2 = '';
    if (this.selectedSiteData.drives.length > 0) {
      this.selectedSiteData.drives.forEach(element => {
        element.isShow = true;
        let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
        if (selectedItemsIdz > -1) {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel2();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel3() {
    if (this.selectedDriveData.children.length > 0) {
      this.selectedDriveData.children.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL3.toLowerCase()) > -1) {
          element.isShow = true;
          let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
          if (selectedItemsIdz > -1) {
            element.isShow = false;
          }
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel3();
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel3() {
    this.searchTextOnL3 = '';
    if (this.selectedDriveData.children.length > 0) {
      this.selectedDriveData.children.forEach(element => {
        element.isShow = true;
        let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
        if (selectedItemsIdz > -1) {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel3();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel4() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL4.toLowerCase()) > -1) {
          element.isShow = true;
          let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
          if (selectedItemsIdz > -1) {
            element.isShow = false;
          }
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel4();
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel4() {
    this.searchTextOnL4 = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
        let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
        if (selectedItemsIdz > -1) {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel4();
    } else {
      this.noResultFound = false;
    }
  }

  applySearchOnLevel5() {
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        if (element.name.toLowerCase().indexOf(this.searchTextOnL5.toLowerCase()) > -1) {
          element.isShow = true;
          let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
          if (selectedItemsIdz > -1) {
            element.isShow = false;
          }
        } else {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel5();
    } else {
      this.noResultFound = false;
    }
  }

  removeSearchOnLevel5() {
    this.searchTextOnL5 = '';
    if (this.driveItems.length > 0) {
      this.driveItems.forEach(element => {
        element.isShow = true;
        let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
        if (selectedItemsIdz > -1) {
          element.isShow = false;
        }
      });
      this.checkIfItemsToShowOnLevel5();
    } else {
      this.noResultFound = false;
    }
  }

  onNewLibKeyPress(event: any): boolean {
    if (event.keyCode === 13) {
      this.createLibrary(event);
    }
    return event.keyCode !== 13;
  }

  onNewLibBlur(event: any) {
    let value: string = event.target.innerText.trim();
    if (value.length === 0) {
      this.isShowAddLibrary = false;
      return;
    }
    this.createLibrary(event);
  }

  showAddLibrary() {
    this.isShowAddLibrary = true;
    setTimeout(() => {
      $('.create-library').trigger('focus');
    }, 750);
  }

  showAddItem(type) {
    this.isShowAddItem = true;
    this.selectedDocType = type;
    setTimeout(() => {
      if (this.selectedDocType !== 5) {
        $('.create-file').trigger('focus');
      } else if (this.selectedDocType === 5) {
        $('.create-folder').trigger('focus');
      }
    }, 750);
  }

  selectDocType(type) {
    this.selectedDocType = type;
  }

  onNewFileKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      this.createFile(event, isOneDrive, level);
    }
    return event.keyCode !== 13;
  }

  onNewFileBlur(event: any, isOneDrive, level) {
    let value: string = event.target.innerText.trim();
    if (value.length > 0) {
      this.createFile(event, isOneDrive, level);
    }
    this.isShowAddItem = false;
  }

  createFile(event, isOneDrive, level): void {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFileInputDto = new CreateFileInputDto();
    input.isShareFile = true;
    input.isOneNote = this.selectedDocType === 4 ? true : false;
    if (level === 0) {
      input.itemId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
      input.driveId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
    } else {
      if (isOneDrive) {
        input.itemId = this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
        input.driveId = this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
      } else {
        if (level === 3) {
          // SharePoint Drive level
          input.driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
        } else {
          // SharePoint Items level
          input.itemId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
          input.driveId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
        }
      }
    }
    input.name = value.trim();
    if (this.selectedDocType === 1) {
      input.extension = '.docx';
    } else if (this.selectedDocType === 2) {
      input.extension = '.xlsx';
    } else if (this.selectedDocType === 3) {
      input.extension = '.pptx';
    }
    this.isSaving = true;
    event.target.innerText = '';
    if (input.itemId === input.driveId) { input.itemId = undefined; }
    this._oneDriveService.createOneDriveFile(input).subscribe(result => {
      this.isSaving = false;
      event.target.innerText = '';
      if (!result.isError) {
        if (level === 0) {
          this.refreshItemsOnLevel0(this.selectedItem[this.selectedItem.length - 1]);
        } else {
          if (level !== 3) {
            this.refreshItemsOnLevel4(this.selectedItem[this.selectedItem.length - 1]);
          } else {
            this.goToChildrenOfDrive(this.selectedDriveData);
          }
        }
      } else if (result.errorMessage) {
        this.operationError = AppConsts.oneDriveErrors[result.errorMessage] ?? {message: result.errorMessage};
        this._showOperationError();
      }
    });
  }

  private _showOperationError(): void {
     if (!this.isOperationErrorShown) {
          this.isOperationErrorShown = true;
          this.operationErrorShell.show();
     }
  }

  showUploadError(code: string): void {
    const base = code ? AppConsts.oneDriveErrors[code] : { message: code };
    this.operationError = { ...base, title: "Couldn't upload this file" };
    this.operationErrorShell.show();
  }

  closeUploadError(): void {
    this.operationErrorShell.hide();
  }

  onErrorCancel(): void {
    if (this.isOperationErrorShown) { this.closeOperationError(); } else { this.closeUploadError(); }
  }

  closeOperationError(): void {
    this.operationErrorShell.hide();
    this.isOperationErrorShown = false;
    this.copyMoveMsFileInputs = [];
    this._pendingRenameItems = [];
    this.dataService.refreshListAfterCopyOrMove.next();
    if (!this.modal.isShown && !this.copyOrMoveProgressModal.isShown) {
      this.clearData();
      this.onClose.emit();
      this.updateBodyForCenterModalHide();
    }
  }

  confirmOperationError(): void {
    if (this.moveOnOperation) {
      // this.operationErrorShell.hide();
      // this.isOperationErrorShown = false;
      // this.copyMoveMsFileInputs = [];
      if (this.moveOnOperation === 'onedrive') { this.moveOnOneDrive(); }
      else if (this.moveOnOperation === '0') { this.moveOnLevel0(); }
      else if (this.moveOnOperation === '3') { this.moveOnLevel3(); }
      else if (this.moveOnOperation === '5') { this.moveOnLevel5(); }
    } else if (this._pendingRenameItems.length > 0) {
      this.operationErrorShell.hide();
      this.isOperationErrorShown = false;
      this._processNextRenameItem();
      return;
    } else if (this.copyMoveMsFileInputs.length > 0) {
      this.operationErrorShell.hide();
      this.isOperationErrorShown = false;
      const items = this.copyMoveMsFileInputs.slice();
      this.copyMoveMsFileInputs = [];
      let remaining = items.length;
      let succeeded = 0;
      const finish = () => {
        if (--remaining > 0) { return; }
        if (succeeded > 0) {
          // this.dataService.refreshListAfterCopyOrMove.next();
          this.dataService.refreshFilesSlider.next();
          const msg = this.isCopy
            ? 'Your item was <b>copied successfully!</b>'
            : 'Your item was <b>moved successfully!</b>';
          this.toastr.success(msg, null, this.toastrOptions);
        }
        // if (!this.modal.isShown && !this.copyOrMoveProgressModal.isShown && !this.isOperationErrorShown) {
        //   this.clearData();
        //   this.onClose.emit();
        //   this.updateBodyForCenterModalHide();
        // }
         this.closeOperationError();
      };
      items.forEach(item => {
        const onItemResult = (result: { isError: boolean; errorMessage: string }) => {
          if (!result.isError) {
            succeeded++;
          } else {
            this._lastErrorCode = result.errorMessage;
            this.operationError = AppConsts.oneDriveErrors[result.errorMessage] ?? {message: result.errorMessage};
            if (result.errorMessage === '106' || result.errorMessage === '107' || result.errorMessage === '111' || result.errorMessage === '114') {
              this.copyMoveMsFileInputs.push(item);
            } else if (result.errorMessage === '101') {
              this._pendingRenameItems.push(item);
            }
            this._showOperationError();
          }
          finish();
        };
        if (this.isCopy) {
          this._oneDriveService.copyMsFile(item).subscribe(onItemResult);
        } else {
          this._oneDriveService.moveMsFile(item).subscribe(onItemResult);
        }
      });
    } 
  }

  private _processNextRenameItem(): void {
    if (this._pendingRenameItems.length === 0) {
        this._showOperationError();
      return;
    }
    const item = this._pendingRenameItems.shift()!;
    this.dataService.openRenameFileModal.next({ ...item, skipRenameCall: true });
    this.dataService.copyMoveRenameResult.pipe(take(1)).subscribe(newName => {
      if (!newName) {
        this._processNextRenameItem();
        return;
      }
      item.duplicateAction = 0;
      item.fileName = newName;
      const onRenameResult = (result: any) => {
        if (!result.isError) {
          this.dataService.refreshListAfterCopyOrMove.next();
          this.dataService.refreshFilesSlider.next();
          const msg = this.isCopy
            ? 'Your item was <b>copied successfully!</b>'
            : 'Your item was <b>moved successfully!</b>';
          this.toastr.success(msg, null, this.toastrOptions);
        } else {
          this.operationError = AppConsts.oneDriveErrors[result.errorMessage] ?? { message: result.errorMessage };
          if (result.errorMessage === '101') {
            this._pendingRenameItems.unshift(item);
          } else if (result.errorMessage === '106' || result.errorMessage === '107' || result.errorMessage === '111' || result.errorMessage === '114') {
            this.copyMoveMsFileInputs.push(item);
          }
        }
        if(this._pendingRenameItems.length > 0){
          this._processNextRenameItem();
        }
      };
      if (this.isCopy) {
        this._oneDriveService.copyMsFile(item).subscribe(onRenameResult);
      } else {
        this._oneDriveService.moveMsFile(item).subscribe(onRenameResult);
      }
    });
  }

  okInfoPopupClicked(ev: any) {
    this.closeOperationError();
  }

  refreshItemsOnLevel4(item) {
    this.isFolderEmpty = false;
    this.nextBatchLink = '';
    this.isSharePointSitesLoading = true;
    this._oneDriveService.getMsFiles(item.id ? item.parentReference.driveId : undefined, item.id && item.parentReference?.driveId !== item.id ? item.id : undefined, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
            this.refreshItemsInItemsHistory(this.driveItems);
          } else {
            this.isFolderEmpty = true;
          }
          // this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
    // if (item.id) {
    //   this.isSharePointSitesLoading = true;
    //   // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         element.isShow = true;
    //   //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //   //         if (selectedItemsIdz > -1) {
    //   //           element.isShow = false;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //   }
    //   // });
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(item.parentReference.driveId, item.id, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             element.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         this.setItems(this.driveItems);
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // } else {
    //   this.isSharePointSitesLoading = true;
    //   // this._oneDriveService.getMyFilesOnOneDrive().subscribe(result => {
    //   //   this.isSharePointSitesLoading = false;
    //   //   if (!result.isError) {
    //   //     if (result.responseData.length > 0) {
    //   //       this.driveItems = result.responseData;
    //   //       this.driveItems.forEach(element => {
    //   //         element.isSelected = false;
    //   //         element.isShow = true;
    //   //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //   //         if (selectedItemsIdz > -1) {
    //   //           element.isShow = false;
    //   //         }
    //   //       });
    //   //     } else {
    //   //       this.isFolderEmpty = true;
    //   //     }
    //   //   }
    //   // });
    //   this.nextBatchLink = '';
    //   this._oneDriveService.getMsFiles(undefined, undefined).subscribe(result => {
    //     this.isSharePointSitesLoading = false;
    //     if (!result.isError) {
    //       if (result.responseData) {
    //         if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
    //           this.driveItems = result.responseData['item1'];
    //           this.driveItems.forEach(element => {
    //             element.isSelected = false;
    //             element.isShow = true;
    //             let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //             if (selectedItemsIdz > -1) {
    //               element.isShow = false;
    //             }
    //           });
    //         } else {
    //           this.isFolderEmpty = true;
    //         }
    //         if (result.responseData['item2']) {
    //           this.nextBatchLink = result.responseData['item2'];
    //         } else {
    //           this.nextBatchLink = '';
    //         }
    //       }
    //     }
    //   });
    // }
  }

  refreshItemsOnLevel5(item) {
    this.isFolderEmpty = false;
    this.isSharePointSitesLoading = true;
    // this._oneDriveService.getDriveItemsByItemId(item.parentReference.driveId, item.id).subscribe(result => {
    //   this.isSharePointSitesLoading = false;
    //   if (!result.isError) {
    //     if (result.responseData.length > 0) {
    //       this.driveItems = result.responseData;
    //       this.driveItems.forEach(element => {
    //         element.isSelected = false;
    //         element.isShow = true;
    //         let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
    //         if (selectedItemsIdz > -1) {
    //           element.isShow = false;
    //         }
    //       });
    //     } else {
    //       this.isFolderEmpty = true;
    //     }
    //   }
    // });
    this.nextBatchLink = '';
    this._oneDriveService.getMsFiles(item.parentReference.driveId, item.parentReference.driveId === item.id ? undefined : item.id, undefined, undefined).subscribe(result => {
      this.isSharePointSitesLoading = false;
      if (!result.isError) {
        if (result.responseData) {
          if (result.responseData['item1'] && result.responseData['item1'].length > 0) {
            this.driveItems = result.responseData['item1'];
            this.driveItems.forEach(element => {
              element.isSelected = false;
              element.isShow = true;
              let selectedItemsIdz = this.moveOrCopyItems.findIndex(x => x.fileId === element.id);
              if (selectedItemsIdz > -1) {
                element.isShow = false;
              }
            });
            this.refreshItemsInItemsHistory(this.driveItems);
          } else {
            this.isFolderEmpty = true;
          }
          // this.setItems(this.driveItems);
          if (result.responseData['item2']) {
            this.nextBatchLink = result.responseData['item2'];
          } else {
            this.nextBatchLink = '';
          }
        }
      }
    });
  }

  onNewFolderKeyPress(event: any, isOneDrive, level): boolean {
    if (event.keyCode === 13) {
      this.createFolder(event, isOneDrive, level);
    }
    return event.keyCode !== 13;
  }

  onNewFolderBlur(event: any, isOneDrive, level) {
    let value: string = event.target.innerText.trim();
    if (value.length > 0) {
      this.createFolder(event, isOneDrive, level);
    }
    this.isShowAddItem = false;
  }

  createFolder(event, isOneDrive, level): void {
    let value: string = event.target.innerText.trim();
    let len = value.length;
    if (len === 0) {
      return;
    }
    if (this.isSaving) {
      return;
    }
    let input: CreateFolderDto = new CreateFolderDto();
    input.isDocLibrary = false;
    input.isRename = false;
    if (level === 0) {
      input.itemId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
      input.driveId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
    } else {
      if (isOneDrive) {
        input.itemId = this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
        input.driveId = this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
      } else {
        if (level === 3) {
          // SharePoint Drive level
          input.driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
        } else {
          // SharePoint Items level
          input.itemId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
          input.driveId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
        }
      }
    }
    input.name = value.trim();
    input.folderType = this.selectedItem.length === 1 ? 1 : 3;
    this.isSaving = true;
    event.target.innerText = '';
    this._oneDriveService.createFolder(input).subscribe(result => {
      this.isSaving = false;
      event.target.innerText = '';
      if (!result.isError) {
        if (level === 0) {
          this.refreshItemsOnLevel0(this.selectedItem[this.selectedItem.length - 1]);
        } else {
          if (level !== 3) {
            this.refreshItemsOnLevel4(this.selectedItem[this.selectedItem.length - 1]);
          } else {
            this.goToChildrenOfDrive(this.selectedDriveData);
          }
        }
      } else if (result.errorMessage) {
        this.operationError = AppConsts.oneDriveErrors[result.errorMessage] ?? {message: result.errorMessage};
        this._showOperationError();
      }
    });
  }

  triggerFileControl(): void {
    $('#fileUploadOneDrive').trigger('click');
  }

  fileInputChanged(event, isOneDrive, level): void {
    if (event.target.value) {
      if (event.target.files) {
        this.uploadingItems = [];
        let files = [];
        files = event.target.files;
        if (event.target.files.length > 0) {
          for (let index = 0; index < event.target.files.length; index++) {
            const element = event.target.files[index];
            if (element.size >= AppConsts.uploadFileSize) {
              this.toastr.error(`"${element.name}" is too large to upload. Maximum size is 25 MB.`, null, this.toastrOptions);
              this.fileUploadError = true;
              this.fileErrorMsg = 'Cannot upload file above 25mb.';
            } else if (element.size === 0) {
              this.toastr.error(`"${element.name}" is empty and can't be uploaded.`, null, this.toastrOptions);
              this.fileUploadError = true;
              this.fileErrorMsg = 'Cannot upload file with 0kb.';
            }
          }
          this.fileRawData = [];
          if (!this.fileUploadError) {
            let fileCts = event.target.files.length;
            for (let index = 0; index < event.target.files.length; index++) {
              const element = event.target.files[index];
              this.fileUploadError = false;
              this.fileCtrl = event.target.files[0].name;
              let file = element;
              this.fileRawData.push(file);
              fileCts--;
              if (fileCts <= 0) {
                this.isUploadFiles = true;
                this.uploadFileToSpecificFolder(isOneDrive, level);
                event.target.value = null;
              }
            }
          } else {
            this.fileUploadError = false;
          }
        }
      }
    }
  }

  uploadFileToSpecificFolder(isOneDrive, level) {
    if (this.fileRawData.length > 0) {
      let fileCts = this.fileRawData.length;
      this.uploadingItems = [];
      let options = this.toastrOptions;
      this.toastr
        .success('We are uploading file(s). Please wait for a while.',
          null, options);
      this.fileRawData.forEach((element, index) => {
        let itemId = '';
        let driveId = '';
        if (level === 0) {
          itemId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
          driveId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
        } else {
          if (isOneDrive) {
            itemId = this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
            driveId = this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
          } else {
            if (level === 3) {
              // SharePoint Drive level
              driveId = this.selectedDriveData ? this.selectedDriveData.id : '';
            } else {
              // SharePoint Items level
              itemId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].id : '';
              driveId = this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id ? this.selectedItem[this.selectedItem.length - 1].parentReference.driveId : '';
            }
          }
        }
        if (driveId === itemId) {
          itemId = undefined;
        }
        this.isSaving = true;
        this._oneDriveService.uploadFile({ data: element, fileName: element.name } as FileParameter, driveId, itemId, 0).subscribe(result => {
          if (!result.isError) {
            fileCts--;
            if (fileCts <= 0) {
              this.isSaving = false;
              let options = this.toastrOptions;
              this.toastr
                .success('File(s) uploaded successfully.',
                  null, options);
              if (level === 0) {
                this.refreshItemsOnLevel0(this.selectedItem[this.selectedItem.length - 1]);
              } else {
                if (level !== 3) {
                  this.refreshItemsOnLevel4(this.selectedItem[this.selectedItem.length - 1]);
                } else {
                  this.goToChildrenOfDrive(this.selectedDriveData);
                }
              }
            }
          } else {
            this.isSaving = false;
            if (AppConsts.oneDriveErrors[result.errorMessage]) {
              this.showUploadError(result.errorMessage);
            } else {
              this.fileUploadError = true;
              this.fileErrorMsg = 'Something went wrong while uploading file.';
            }
          }
        });
      });
    }
  }

  openInM365(item) {
    window.open(item.webUrl, '_blank');
  }

  openAddToTask(item) {
    this.dataService.openFileToTaskModal.next([item, 'M365']);
  }

  // Emits the destination-confirmed event with all file IDs that are about to
  // be moved/copied, so the source modal can mark inline "Moving…"/"Copying…"
  // badges on the affected rows (matches the drag-drop animation). Called once
  // per click, before the per-item API loop starts.
  private _emitMoveCopyOperationStarted(operation: 'move' | 'copy'): void {
    const fileIds = (this.moveOrCopyItems || [])
      .map((item: any) => item?.fileId)
      .filter((id: any) => !!id);
    if (fileIds.length > 0) {
      this.dataService.moveCopyOperationStarted.next({ operation, fileIds });
    }
  }

  moveOnOneDrive(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('move');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;
        if (this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id) {
          input.toDriveId = this.selectedItem[this.selectedItem.length - 1].parentReference.driveId;
          input.toItemId = this.selectedItem[this.selectedItem.length - 1].id;
          input.toSiteId = this.selectedItem[this.selectedItem.length - 1].parentReference.siteId;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        } else {
          input.toDriveId = null
          input.toItemId = null
          input.toSiteId = null;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        }
        input.duplicateAction = 0;
        // Hide the picker visually so the user gets snappy feedback, but keep the
        // component alive so internal error popups (101 rename/replace, 103 perms,
        // 104/105 not-allowed, 106 locked, 107 version-limit) can still fire when
        // the API response settles. Chained close handlers emit onClose later.
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.moveMsFileFolder(input, item, 'onedrive');
      });
    }
  }

  moveOnLevel0(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('move');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;
        if (this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id) {
          input.toDriveId = this.selectedItem[this.selectedItem.length - 1].parentReference.driveId;
          input.toItemId = this.selectedItem[this.selectedItem.length - 1].id;
          input.toSiteId = this.selectedItem[this.selectedItem.length - 1].parentReference.siteId;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        } else {
          input.toDriveId = null
          input.toItemId = null
          input.toSiteId = null;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        }
        input.duplicateAction = 0;
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.moveMsFileFolder(input, item, '0');
      });
    }
  }

  moveOnLevel3(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('move');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;

        input.toSiteId = this.selectedSiteData.id;
        input.toDriveId = this.selectedSiteData.drives.filter(x => x.isSelected === true)[0].id;
        this.moveOrCopyToLocationName = this.selectedSiteData.drives.filter(x => x.isSelected === true)[0].name;
        input.duplicateAction = 0;
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.moveMsFileFolder(input, item, '3');
      });
    }
  }

  moveOnLevel5(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('move');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;
        if (this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id) {
          input.toDriveId = this.selectedItem[this.selectedItem.length - 1].parentReference.driveId;
          input.toItemId = this.selectedItem[this.selectedItem.length - 1].id;
          input.toSiteId = this.selectedItem[this.selectedItem.length - 1].parentReference.siteId;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        } else {
          input.toItemId = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].id;
          input.toSiteId = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].parentReference.siteId;
          input.toDriveId = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].parentReference.driveId;
          this.moveOrCopyToLocationName = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].name;
        }
        input.duplicateAction = 0;
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.moveMsFileFolder(input, item, '5');
      });
    }
  }

  copyOnOneDrive(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('copy');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;
        if (this.selectedItem.length > 1 && this.selectedItem[this.selectedItem.length - 1].id) {
          input.toDriveId = this.selectedItem[this.selectedItem.length - 1].parentReference.driveId;
          input.toItemId = this.selectedItem[this.selectedItem.length - 1].id;
          input.toSiteId = this.selectedItem[this.selectedItem.length - 1].parentReference.siteId;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        } else {
          input.toDriveId = null
          input.toItemId = null
          input.toSiteId = null;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        }
        input.duplicateAction = 0;
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.copyMsFileFolder(input, item);
      });
    }
  }

  copyOnLevel0(): void {
    let that = this;
    if (that.moveOrCopyItems.length > 0) { // move
      that._emitMoveCopyOperationStarted('copy');
      that.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;
        if (that.selectedItem.length > 0 && that.selectedItem[that.selectedItem.length - 1].id) {
          if (that.selectedItem[that.selectedItem.length - 1].extension === 'documentLibrary') {
            input.toDriveId = that.selectedItem[that.selectedItem.length - 1].driveId;
            input.toSiteId = that.selectedItem[that.selectedItem.length - 1].siteId;
          } else {
            input.toDriveId = that.selectedItem[that.selectedItem.length - 1].parentReference.driveId;
            input.toSiteId = that.selectedItem[that.selectedItem.length - 1].parentReference.siteId;
            input.toItemId = that.selectedItem[that.selectedItem.length - 1].id;
          }
          that.moveOrCopyToLocationName = that.selectedItem[that.selectedItem.length - 1].name;
        } else {
          input.toDriveId = null
          input.toItemId = null
          input.toSiteId = null;
          that.moveOrCopyToLocationName = that.selectedItem[that.selectedItem.length - 1].name;
        }
        input.duplicateAction = 0;
        that.modal.hide();
        that.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        that.copyMsFileFolder(input, item);
      });
    }
  }

  copyOnLevel3(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('copy');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;

        input.toSiteId = this.selectedSiteData.id;
        input.toDriveId = this.selectedSiteData.drives.filter(x => x.isSelected === true)[0].id;
        this.moveOrCopyToLocationName = this.selectedSiteData.drives.filter(x => x.isSelected === true)[0].name;
        input.duplicateAction = 0;
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.copyMsFileFolder(input, item);
      });
    }
  }

  copyOnLevel5(): void {
    if (this.moveOrCopyItems.length > 0) { // move
      this._emitMoveCopyOperationStarted('copy');
      this.moveOrCopyItems.forEach((element, index) => {
        let itemToMove = element;
        let input = new CopyMoveMsFileInputDto();
        input.fileName = itemToMove.name;
        input.fileId = itemToMove.fileId;
        input.fromDriveId = itemToMove.driveId;
        input.fromSiteId = itemToMove.siteId;
        if (this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1].id) {
          input.toDriveId = this.selectedItem[this.selectedItem.length - 1].parentReference.driveId;
          input.toItemId = this.selectedItem[this.selectedItem.length - 1].id;
          input.toSiteId = this.selectedItem[this.selectedItem.length - 1].parentReference.siteId;
          this.moveOrCopyToLocationName = this.selectedItem[this.selectedItem.length - 1].name;
        } else {
          input.toItemId = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].id;
          input.toSiteId = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].parentReference.siteId;
          input.toDriveId = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].parentReference.driveId;
          this.moveOrCopyToLocationName = this.selectedDriveData.children.filter(x => x.isSelected === true)[0].name;
        }
        input.duplicateAction = 0;
        this.modal.hide();
        this.copyOrMoveIndex = index + 1;
        let item: any = cloneDeep(input);
        item.isError = false;
        item.extension = itemToMove.extension;
        this.copyMsFileFolder(input, item);
      });
    }
  }

  closeProgressModal(): void {
    this.copyOrMoveProgressModal.hide();
    if (!this.modal.isShown && !this.isOperationErrorShown) {
      this.clearData();
      this.onClose.emit();
      this.updateBodyForCenterModalHide();
    }
  }

  closeMoveNotAllowedPopup(): void {
    this.closeOperationError();
  }

  closeError106Modal(): void {
    this.closeOperationError();
  }

  closeError107Modal(): void {
    this.closeOperationError();
  }

  retryMove() {
    this.confirmOperationError();
  }

  openM36Location() {
    let driveId = null;
    let itemId = null;
    if (this.originalData) {
      if (this.originalData.items && this.originalData.items.length > 0) {
        this.originalData.items.forEach(element => {
          driveId = element.driveId;
          itemId = element.fileId;
        });
      }
    }
    if (driveId && itemId) {
      this._oneDriveService.getFileUrl(itemId, driveId, 2).subscribe(result => {
        if (!result.isError && result.responseData) {
          window.open(result.responseData, '_blank');
          this.closeOperationError();
        } else {
          this.showUploadError(result.errorMessage);
        }
      });
    }
  }

  initializeSearchOnLevel1() {
    this.noSharePointSiteResultFound = false;
    this.searchTextOnL1 = '';
    console.log('Initializing search on Level 1');
    $('.level-1cm-search .input-group-append').hide();
    $('.level-1cm-search .form-control').on('keyup blur', function () {
      let div = $('.level-1cm-search .input-group-append');
      if ($('.level-1cm-search .form-control').val() !== '') {
        $(this).addClass('focus');
        div.show();
      } else {
        div.hide();
        $(this).removeClass('focus');
      }
    });
    $('.level-1cm-search .input-group-append').on('click', function () {
      $('.level-1cm-search .form-control').trigger('focus');
    });
  }
  
  applySearchOnLevel1() {
    if (this.searchTextOnL1.trim() !== '' && this.searchTextOnL1.length > 2) {
      this.onSearching.next();
    } else if (this.searchTextOnL1.trim() === '') {
      this.noSharePointSiteResultFound = false;
      this.getSharepointSites();
    }
  }

  removeSearchOnLevel1() {
    this.searchTextOnL1 = '';
    this.noSharePointSiteResultFound = false;
    this.getSharepointSites();
  }

  switchTab(tab: 'sharepoint' | 'onedrive') {
    if (this.activeTab === tab) return;
    this.activeTab = tab;
    this.isShowNewFolderInput = false;
    this.newFolderName = '';
    this.isShowAddItem = false;
    this.isShowAddLibrary = false;
    if (tab === 'onedrive') {
      if (this.level !== 0 && this.level !== 4) {
        this.getMyFilesOnOneDrive();
      }
    } else {
      if (this.level !== 1 && this.level !== 2 && this.level !== 3 && this.level < 5) {
        this.level = 1;
        this.selectedItem = [];
        this.driveItems = [];
        this.isFolderEmpty = false;
        this.noResultFound = false;
        this.getSharepointSites();
      }
    }
  }

  private fetchBreadcrumb(selectedLocation: any) {
    let driveId = '';
    let itemId = '';
    if (selectedLocation.extension === 'documentLibrary') {
      driveId = selectedLocation.keyId || selectedLocation.id;
    } else {
      driveId = selectedLocation.driveId || selectedLocation.parentReference?.driveId || '';
      itemId = selectedLocation.keyId || selectedLocation.id || '';
    }
    // siteId is typically not on the selectedLocation (breadcrumb item) — get it from the items being moved/copied
    let siteId = selectedLocation.msSiteId || selectedLocation.siteId || selectedLocation.parentReference?.siteId
      || (this.moveOrCopyItems?.length > 0 ? this.moveOrCopyItems[0].siteId || this.moveOrCopyItems[0].parentReference?.siteId : undefined)
      || undefined;
    if (driveId) {
      this._oneDriveService.getFolderBreadcrumb(driveId, itemId || undefined, siteId).subscribe(result => {
        if (!result.isError && result.responseData) {
          const bcItems = [];
          result.responseData.forEach(bc => {
            if (bc.type === 'site') {
              bcItems.push({ id: bc.id, name: bc.name, displayName: bc.name, bcType: 'site' });
            } else if (bc.type === 'documentLibrary') {
              bcItems.push({ id: bc.driveId, name: bc.name, extension: 'documentLibrary', bcType: 'documentLibrary' });
            } else if (bc.type === 'folder') {
              bcItems.push({ id: bc.id, name: bc.name, extension: 'folder', parentReference: { driveId: bc.driveId }, bcType: 'folder' });
            }
          });
          this.spBreadcrumb = bcItems;
        }
      });
    }
  }

  get isOneDriveTab(): boolean {
    return this.activeTab === 'onedrive';
  }

  get isSharePointTab(): boolean {
    return this.activeTab === 'sharepoint';
  }

  toggleNewFolderInput() {
    this.isShowNewFolderInput = !this.isShowNewFolderInput;
    this.newFolderName = '';
    if (this.isShowNewFolderInput) {
      setTimeout(() => {
        const el = document.getElementById('cmNewFolderInput');
        if (el) el.focus();
      }, 100);
    }
  }

  createNewFolderFromInput() {
    if (!this.newFolderName.trim()) return;
    // Create a synthetic event-like object for the existing createFolder method
    const fakeEvent = {
      target: { innerText: this.newFolderName.trim() },
      keyCode: 13
    };
    const isOneDrive = this.level === 0 || this.level === 4;
    this.onNewFolderBlur(fakeEvent, isOneDrive, this.level);
    this.isShowNewFolderInput = false;
    this.newFolderName = '';
  }

  cancelNewFolderInput() {
    this.isShowNewFolderInput = false;
    this.newFolderName = '';
  }

  get currentSearchText(): string {
    if (this.level === 0) return this.searchTextOnL0;
    if (this.level === 1) return this.searchTextOnL1;
    if (this.level === 2) return this.searchTextOnL2;
    if (this.level === 3) return this.searchTextOnL3;
    if (this.level === 4) return this.searchTextOnL4;
    return this.searchTextOnL5;
  }

  set currentSearchText(val: string) {
    if (this.level === 0) this.searchTextOnL0 = val;
    else if (this.level === 1) this.searchTextOnL1 = val;
    else if (this.level === 2) this.searchTextOnL2 = val;
    else if (this.level === 3) this.searchTextOnL3 = val;
    else if (this.level === 4) this.searchTextOnL4 = val;
    else this.searchTextOnL5 = val;
  }

  onSearchInput() {
    if (this.level === 0) this.applySearchOnLevel0();
    else if (this.level === 1) this.applySearchOnLevel1();
    else if (this.level === 2) this.applySearchOnLevel2();
    else if (this.level === 3) this.applySearchOnLevel3();
    else if (this.level === 4) this.applySearchOnLevel4();
    else this.applySearchOnLevel5();
  }

  clearCurrentSearch() {
    if (this.level === 0) this.removeSearchOnLevel0();
    else if (this.level === 1) this.removeSearchOnLevel1();
    else if (this.level === 2) this.removeSearchOnLevel2();
    else if (this.level === 3) this.removeSearchOnLevel3();
    else if (this.level === 4) this.removeSearchOnLevel4();
    else this.removeSearchOnLevel5();
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[d.getMonth()] + ' ' + d.getDate();
  }

  onGoBack() {
    if (this.level === 0) this.goBack0();
    else if (this.level === 2) this.backToSelectLocation();
    else if (this.level === 3) this.backToSelectedDrive();
    else if (this.level === 4) this.goBack();
    else if (this.level > 4) this.goBackSP();
  }

  onMoveOrCopy() {
    if (this.level === 0) { this.isCopy ? this.copyOnLevel0() : this.moveOnLevel0(); }
    else if (this.level === 3) { this.isCopy ? this.copyOnLevel3() : this.moveOnLevel3(); }
    else if (this.level === 4) { this.isCopy ? this.copyOnOneDrive() : this.moveOnOneDrive(); }
    else if (this.level > 4) { this.isCopy ? this.copyOnLevel5() : this.moveOnLevel5(); }
  }

  get canMoveOrCopy(): boolean {
    return this.level !== 1 && this.level !== 2;
  }
}
